import {ProductReviewProvider} from './context/ProductReviewContext'
import {ProductReview} from './ProductReview'

export const ProductReviewPage = () => {
  return (
    <ProductReviewProvider>
      <ProductReview />
    </ProductReviewProvider>
  )
}
